/**
 * i18n.js
 *
 * This will setup the i18n language files and locale data for your app.
 *
 */
import "@formatjs/intl-relativetimeformat/polyfill";
import "@formatjs/intl-relativetimeformat/locale-data/en";
import "@formatjs/intl-relativetimeformat/locale-data/es";
import "@formatjs/intl-relativetimeformat/locale-data/fr";
import "@formatjs/intl-relativetimeformat/locale-data/it";
import "@formatjs/intl-relativetimeformat/locale-data/hi";
import "@formatjs/intl-relativetimeformat/locale-data/el";
import "@formatjs/intl-relativetimeformat/locale-data/zh";
import "@formatjs/intl-relativetimeformat/locale-data/ga";
import "@formatjs/intl-relativetimeformat/locale-data/fil";
import "@formatjs/intl-relativetimeformat/locale-data/pl";
import "@formatjs/intl-relativetimeformat/locale-data/pt";
import "@formatjs/intl-relativetimeformat/locale-data/de";
import "@formatjs/intl-relativetimeformat/locale-data/ar";
import "@formatjs/intl-relativetimeformat/locale-data/uk";

import "@formatjs/intl-pluralrules/polyfill";
import "@formatjs/intl-pluralrules/locale-data/en";
import "@formatjs/intl-pluralrules/locale-data/es";
import "@formatjs/intl-pluralrules/locale-data/fr";
import "@formatjs/intl-pluralrules/locale-data/it";
import "@formatjs/intl-pluralrules/locale-data/hi";
import "@formatjs/intl-pluralrules/locale-data/el";
import "@formatjs/intl-pluralrules/locale-data/zh";
import "@formatjs/intl-pluralrules/locale-data/ga";
import "@formatjs/intl-pluralrules/locale-data/fil";
import "@formatjs/intl-pluralrules/locale-data/pl";
import "@formatjs/intl-pluralrules/locale-data/pt";
import "@formatjs/intl-pluralrules/locale-data/de";
import "@formatjs/intl-pluralrules/locale-data/ar";
import "@formatjs/intl-pluralrules/locale-data/uk";

const { REACT_APP_API_BASE_URL } = process.env;

const getTranslations = async (locale) => {
  const response = await fetch(REACT_APP_API_BASE_URL + "/translations", {
    headers: { "Accept-Language": locale },
  });
  const trans = await response.json();

  return trans.reward_store;
};

export const inferUserLanguage = () => {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const queryParams = Object.fromEntries(urlSearchParams.entries());
  const languageFromQueryParam = queryParams.language;
  const languageFromLocalStorage = localStorage.getItem("injectedLanguage");
  const navigatorLanguage = navigator.language.split("-")[0];
  return (
    languageFromQueryParam ?? languageFromLocalStorage ?? navigatorLanguage
  );
};

export const translationMessages = async () => {
  const inferedUserLanguage = inferUserLanguage();
  const traduction = await getTranslations(inferedUserLanguage);
  return {
    [inferedUserLanguage]: traduction,
  };
};
